import axios from "axios";
import { baseUrlPostGres } from "../constant";
import HandleError from "../HandleError";
import { apiHeader } from "./ApiHeader";
import {
    IS_LOADING, NOTIFICATION_SEND_MSG_SUCCESS,NOTIFICATION_SEND_MSG_ERROR,
    NOTIFICATION_LIST_SUCCESS,NOTIFICATION_LIST_ERROR
} from "./Type";
import { apiVersion } from "src/utils/apiVersion";


export const SendNotificationAction = (data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/notification/send_message`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: NOTIFICATION_SEND_MSG_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: NOTIFICATION_SEND_MSG_ERROR,
                payload: errors
            })
        })
}

export const ListNotificationAction = (page, size, data) => async (dispatch) => {
    dispatch({ type: IS_LOADING })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/notification/list?page=${page}&size=${size}`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: NOTIFICATION_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: NOTIFICATION_LIST_ERROR,
                payload: errors
            })
        })
}


